
const HomePage = () => {
  const date = new Date();
  const hour = date.getHours(); 
  var greeting: string = "A Bit Late, No?"
  
  if      (hour > 21) greeting = "Good Night!";
  else if (hour > 17) greeting = "Good Evening!";
  else if (hour > 13) greeting = "Good Afternoon!";
  else if (hour > 10) greeting = "Good Day!";
  else if (hour > 4) greeting = "Good Morning!";

  return (
    <>
      <h1>{greeting}</h1>
      <p>My name is Adam Magnusson.</p>
      <p>
        I'm a computer science graduate with a master's degree in high performance computer systems from Chalmers University of Technology.
      </p>
      <p>
        I enjoy prodding at computers from hardware level all the way up to web development. 
        This is however my first project in React, so please forgive any potential jank.
      </p>
      <p>
        If you would like to connect with me professionally, you can message me on <a href="https://www.linkedin.com/in/adam-magnusson">LinkedIn</a>.
      </p>
    </>
  );
}

export default HomePage
